import React from "react";

export default function NoIntent() {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.49985 0.615234C10.504 0.615234 12.9496 3.00712 13.036 5.9904L13.0383 6.1537C14.0579 6.1537 14.8845 6.98025 14.8845 7.99985V9.23062C14.8845 10.2502 14.0579 11.0768 13.0383 11.0768L12.8597 11.0774C12.3726 12.7132 10.94 13.9416 9.19579 14.1289C8.98662 14.5102 8.58116 14.7691 8.11523 14.7691C7.4355 14.7691 6.88447 14.218 6.88447 13.5383C6.88447 12.8586 7.4355 12.3075 8.11523 12.3075C8.55801 12.3075 8.94617 12.5414 9.163 12.8922C10.254 12.7395 11.1616 12.0136 11.572 11.0287C11.3486 10.937 11.1922 10.7175 11.1922 10.4614V6.76908C11.1922 6.42921 11.4677 6.1537 11.8075 6.1537C11.8075 3.77462 9.87892 1.846 7.49985 1.846C5.17034 1.846 3.27271 3.6951 3.19466 6.0056L3.19216 6.1537C3.53203 6.1537 3.80754 6.42921 3.80754 6.76908V10.4614C3.80754 10.8013 3.53203 11.0768 3.19216 11.0768H1.96139C0.941786 11.0768 0.115234 10.2502 0.115234 9.23062V7.99985C0.115234 6.98025 0.941786 6.1537 1.96139 6.1537C1.96139 3.09489 4.44104 0.615234 7.49985 0.615234Z"
          fill="#2F3941"
        />
      </svg>
    </>
  );
}
